/**
 * Hero Products Accordion JavaScript
 */

document.addEventListener('DOMContentLoaded', function () {
  // Initialize hero products accordion
  const toggleButton = document.querySelector('.hero-products-toggle');
  const collapseElement = document.querySelector('#heroProductsCollapse');

  if (toggleButton && collapseElement) {
    const showText = toggleButton.querySelector('.toggle-text-show');
    const hideText = toggleButton.querySelector('.toggle-text-hide');

    // Handle Bootstrap collapse events
    collapseElement.addEventListener('show.bs.collapse', function () {
      // Update button text and state
      if (showText && hideText) {
        showText.classList.add('d-none');
        hideText.classList.remove('d-none');
      }
      toggleButton.setAttribute('aria-expanded', 'true');
    });

    collapseElement.addEventListener('hide.bs.collapse', function () {
      // Update button text and state
      if (showText && hideText) {
        showText.classList.remove('d-none');
        hideText.classList.add('d-none');
      }
      toggleButton.setAttribute('aria-expanded', 'false');
    });

    // Handle smooth scrolling when accordion opens
    collapseElement.addEventListener('shown.bs.collapse', function () {
      // Scroll to the accordion section with some offset
      const sectionTop =
        collapseElement.getBoundingClientRect().top + window.pageYOffset - 100;

      window.scrollTo({
        top: sectionTop,
        behavior: 'smooth',
      });
    });
  }

  // Handle PDF download tracking (optional analytics)
  const pdfLinks = document.querySelectorAll('.hero-sub-products .btn-link');

  pdfLinks.forEach(link => {
    link.addEventListener('click', function () {
      // PDF download click handler - currently no additional actions needed
      // Future enhancements could include analytics tracking:
      // gtag('event', 'download', { 'file_name': 'product-leaflet.pdf' });
      console.log('PDF link clicked:', this.href);
    });
  });

  // Keyboard accessibility
  toggleButton?.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.click();
    }
  });
});
